module.exports = __webpack_public_path__ + "img/chevron-right.9c59704b.svg";